<template>
  <div>
    si funciona
  </div>
</template>

<script>
export default {
  name: 'CopiasControlProcesosFac',

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>